import {
    REGISTER_EMAIL, SEND_CODE, REGISTER_USER, LOGIN_EMAIL, IS_LOADING_LOGIN_PASSWORD, LOGIN_EMAIL_PASSWORD,
    GET_CATEGORIES, ECONOMIC_ACTIVITIES, IS_LOADING_ECONOMIC_ACTIVITIES, NOT_LOADING_LOGIN_PASSWORD, PERSONAL_CODE_REFERAL, PERSONAL_CODE_REFERAL_ERROR, PERSONAL_CODE_REFERAL_CLEAN
} from '../actions/types'
const initialRegisterEmailState = {
    email: '',
    isLoadingViewLoginPassword: false,
    success: '',
    registerUser: {},
    loginEmail: '',
    nameUser: '',
    errorType: '',
    tokenUser: '',
    model: '',
    code: {
        valid:null,
        user:null,
    },
    categories: [],
    economicActivities: [],
    isLoadingEconomicActivities: true
}
export default function (state = initialRegisterEmailState, action) { //lo que se manda de personasAction en el dispatch es el action
    switch (action.type) { //que me llega la cadena type para el switch y el payload en este caso 
        case PERSONAL_CODE_REFERAL_CLEAN:
            return { ...state, code: {
                valid:null,
                user:null,
            }}
        case PERSONAL_CODE_REFERAL:
            return { ...state, code: {
                user: action.payload,
                valid:true
            }}
            case PERSONAL_CODE_REFERAL_ERROR:
                return { ...state, code: {
                    user: null,
                    valid:false
                }}
        case IS_LOADING_LOGIN_PASSWORD:
            return { ...state, isLoadingViewLoginPassword: true }
        case NOT_LOADING_LOGIN_PASSWORD:
            return { ...state, isLoadingViewLoginPassword: false }
        case REGISTER_EMAIL:                                         // lo configuramos como la respuesta del servidor, es decir la res desde
            return { ...state, email: action.payload.email, errorType: action.payload.errorType, success: action.payload.succes, model: action.payload.model }
        case SEND_CODE:                                          // lo configuramos como la respuesta del servidor, es decir la res desde
            return { ...state, success: action.payload.success, errorType: action.payload.errorType, model: action.payload.model }
        case REGISTER_USER:                                          // lo configuramos como la respuesta del servidor, es decir la res desde
            return { ...state, registerUser: action.payload.registerUser, errorType: action.payload.errorType }
        case LOGIN_EMAIL:
            return {
                ...state, loginEmail: action.payload.email, isLoadingViewLoginPassword: false,
                nameUser: action.payload.data.name
            }
        case LOGIN_EMAIL_PASSWORD:
            return { ...state, errorType: action.payload.errorType, tokenUser: action.payload.tokenUser }
        case ECONOMIC_ACTIVITIES:
            return { ...state, economicActivities: action.payload, isLoadingEconomicActivities: false }
        case IS_LOADING_ECONOMIC_ACTIVITIES:
            return { ...state, isLoadingEconomicActivities: true }
        case GET_CATEGORIES:
            return { ...state, categories: action.payload }
        default:
            return state

    }
}